<template>
    <div>
        <v-flex class="_signup-layout--benefits-section app-bg-sand">
            <v-container>
                <v-layout column justify-center text-xs-center>
                    <v-flex tag="h1" class="_signup-layout--header">Register now</v-flex>
                    <v-flex>
                        <app-btn-toggle-role v-model="user.role"
                                             class="_signup-layout--toggle_role"></app-btn-toggle-role>
                    </v-flex>
                </v-layout>
            </v-container>
            <!--BACKGROUND ELEMENTS-->
            <v-flex v-if="$vuetify.breakpoint.mdAndUp"
                    class="_signup-layout--bg-elements">
                <div v-parallax="$helpers.getSpeedAnimationDown()" class="smooth-parallax">
                  <app-svg-icon name="brand/NG_AGES_5+"
                                color="var(--yellow)"
                                class="svg-icon--ages"></app-svg-icon>
                </div>
                <div v-parallax="$helpers.getSpeedAnimationDown()" class="smooth-parallax">
                  <app-svg-icon name="patterns/NG_Pattern-16"
                                color="none var(--orange)"
                                class="svg-icon--pattern-16"></app-svg-icon>
                </div>
                <div v-parallax="$helpers.getSpeedAnimationUp()" class="smooth-parallax">
                  <app-svg-icon name="patterns/NG_Pattern-03"
                                color="none var(--green)"
                                class="svg-icon--pattern-03"></app-svg-icon>
                </div>
                <div v-parallax="$helpers.getSpeedAnimationDown()" class="smooth-parallax">
                  <app-svg-icon name="brand/NG_HAS_CAR"
                                color="var(--blue)"
                                class="svg-icon--car"></app-svg-icon>
                </div>
            </v-flex>
        </v-flex>
    </div>
</template>

<script>
    export default {
        components: {},

        props: ['user'],

        data () {
            return {
                user: props.user
            }
        }
    }
</script>

<style lang="stylus" scoped>
    ._signup-layout
        &--header
            margin 12px 0
        &--bg-elements
            .smooth-parallax
                top -43px
            .svg-icon
                position absolute
                &--ages
                    width 116px
                    height 116px
                    top -70px
                    left 16%
                    transform rotate(10deg)
                &--pattern-16
                    width 116px
                    height 116px
                    top -80px
                    right 11%
                &--pattern-03
                    width 116px
                    height 116px
                    top 70px
                    left -60px
                    transform rotate(75deg)
                &--car
                    width 116px
                    height 116px
                    top 180px
                    right 10%
                    transform rotate(23deg)
</style>


// WEBPACK FOOTER //
// src/views/app/auth/signup/components/auth-signup-header.vue